import { ProductListFiltersFragment } from '@graphcommerce/magento-product/components/ProductListFilters/ProductListFilters.gql'
import { ProductListLink } from '@graphcommerce/magento-product/components/ProductListLink/ProductListLink'
import { useProductListParamsContext } from '@graphcommerce/magento-product/hooks/useProductListParamsContext'
import { ChipProps, Switch, SxProps, Theme } from '@mui/material'
import { FilterIn } from './FilterEqualType'

type Filter = NonNullable<NonNullable<ProductListFiltersFragment['aggregations']>[number]>
export type FilterCheckboxTypeProps = Filter &
  Omit<ChipProps<'button'>, 'selected' | 'onDelete' | 'component'> & { sx?: SxProps<Theme> }

export function FilterCheckboxType(props: FilterCheckboxTypeProps) {
  const { attribute_code, count, label, options } = props
  const { params } = useProductListParamsContext()
  const currentFilter = params.filters[attribute_code]

  if (!options?.[0]) return null

  const option = options?.[1]?.value === '1' ? options[1] : options[0]
  const isActive = currentFilter?.in?.includes(option.value)

  const filter = isActive ? {} : ({ in: [option.value] } as FilterIn)

  return (
    <ProductListLink
      {...params}
      filters={{ ...params.filters, [attribute_code]: filter }}
      currentPage={undefined}
      noLink
      link={{ replace: true, prefetch: false }}
    >
      <div className='mt-[10px] flex w-full items-center justify-between'>
        <span className='Type-XL-Medium'>{label}</span>
        <Switch checked={isActive} className='m-[-10px]' />
      </div>
    </ProductListLink>
  )
}
